import {flowRight} from 'lodash-es'

import {withRails} from './rails'
import {withTheme} from '../components'

const withProviders = (component) =>
  flowRight([withRails, withTheme])(component)

export default withProviders
